import Vue from 'vue'
import store from '../store'
import { clinicHasFeature } from '@/utils/featureGating'

export const vCan = {
  bind: function (el, binding, vnode) {
    if (
      !JSON.parse(localStorage.getItem('permissions'))?.includes(
        binding.expression?.replace(/'/g, '')?.replace(/"/g, '')
      )
    ) {
      vnode.elm.style.display = 'none'
    }
  }
}

export const vShowFeature = {
  bind: async function (el, binding, vnode) {
    const key = await binding.expression.replace(/'/g, '').replace(/"/g, '')
    const res = await Vue.prototype.api.featureIsActive(key)
    store.dispatch(
      `features/updateFeature`,
      { key, value: res.data.isActive },
      { root: true }
    )
    !store.state.features[key] && (vnode.elm.style.display = 'none')
  }
}

export const vShowProduct = {
  bind: function (el, binding, vnode) {
    const name = binding.expression.replace(/'/g, '').replace(/"/g, '')

    // Gating POR CLÍNICA via helper único (spec 15). A versão anterior lia o
    // localStorage direto e estourava quando 'clinic' era null (JSON.parse(null)
    // → null, e `.clinic_features` em null é TypeError) — o helper trata isso.
    if (!clinicHasFeature({ name })) {
      vnode.elm.style.display = 'none'
    }
  }
}

export const vClickOutside = {
  bind(el, binding) {
    el.clickOutsideEvent = function (event) {
      if (!(el === event.target || el.contains(event.target))) {
        binding.value(event)
      }
    }
    document.addEventListener('click', el.clickOutsideEvent)
  },
  unbind(el) {
    document.removeEventListener('click', el.clickOutsideEvent)
  }
}

export const vClickOutsideStrict = {
  bind(el, binding) {
    el.clickOutsideEvent = function (event) {
      if (!(el === event.target || el.contains(event.target))) {
        binding.value(event)
      }
    }
    document.addEventListener('click', el.clickOutsideEvent, true)
  },
  unbind(el) {
    document.removeEventListener('click', el.clickOutsideEvent, true)
  }
}
